module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.013e861e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Regular.woff
// module id = 333
// module chunks = 3